var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('h1',[_vm._v("Translate DG file")]),_c('progress-component',{attrs:{"script":"TranslateDGFile","formParams":[
          { type: 'file', name: 'file', value: null, label: 'Select file' },
          { type: 'checkbox', name: 'columns[text_slide]', value: true, label: 'Translate slide column' },
          { type: 'checkbox', name: 'columns[title]', value: false, label: 'Translate title column' },
          { type: 'checkbox', name: 'columns[text_author_slide]', value: false, label: 'Translate author column' } ]}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }